import { render, staticRenderFns } from "./postChat.vue?vue&type=template&id=4e364505"
import script from "./postChat.vue?vue&type=script&lang=js"
export * from "./postChat.vue?vue&type=script&lang=js"
import style0 from "./postChat.vue?vue&type=style&index=0&id=4e364505&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports